var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-toggle":"tooltip","title":_vm.text}},[_vm._v("\n    "+_vm._s(_vm.viewText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }